<template>
  <div>
    <ul
      class="space-y-12"
      :class="{
        '[mask-image:linear-gradient(to_bottom,black_70%,transparent)]':
          isCollapsible && !isExpanded,
      }"
      data-test="compatible-products-list-mobile"
    >
      <li
        v-for="(item, index) in visibleProducts"
        :key="item"
        class="label-medium"
        :class="{
          'max-md:text-static-default-low':
            isCollapsible &&
            !isExpanded &&
            index === visibleProducts.length - 1,
        }"
      >
        {{ item }}
      </li>
    </ul>

    <Transition>
      <div
        v-if="hiddenProducts.length > 0"
        v-show="isExpanded"
        class="grid transition-[grid-template-rows] duration-300 ease-in"
        :class="{
          'grid-rows-[0fr]': !isExpanded,
          'grid-rows-[1fr]': isExpanded,
        }"
      >
        <ul :id="LIST_ID_MOBILE" class="space-y-12 mt-12 overflow-hidden">
          <li v-for="item in hiddenProducts" :key="item" class="label-medium">
            {{ item }}
          </li>
        </ul>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { LIST_ID_MOBILE } from '../../CompatibleWith.constants'

defineProps<{
  isCollapsible: boolean
  isExpanded: boolean
  hiddenProducts: string[]
  visibleProducts: string[]
}>()

defineOptions({
  name: 'CompatibleWithProductsListMobile',
})
</script>
